module.exports = __webpack_public_path__ + "media/images/map_icons/Paintball-69c8043aca1567aef46034aab2d18f3a.svg";